import { render, staticRenderFns } from "./FeedPost.vue?vue&type=template&id=653ae138&"
import script from "./FeedPost.vue?vue&type=script&lang=js&"
export * from "./FeedPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports